import React from 'react';

import AppLayout from '@/components/AppLayout';
import ShopSearch from '@/feat-components/ShopSearch';
import { shopSearchGateway } from '@/di-container/shop/search/gateway/server';
import { ShippingAddress, SiDo } from '@remodeling/shop';
import { wrapper } from '@/redux/store';
import {
  CURRENT_LEVEL,
  SOUTH_KOREA_LAT,
  SOUTH_KOREA_LEVEL_MAX,
  SOUTH_KOREA_LNG,
} from '@/constants';
import { setShopSearchUrlParam } from '@/redux/reducers/shopSearch';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import { PAGE_SEO } from '@/constants/seo';

interface ShopPageProps {
  siDoList?: SiDo[];
  address?: ShippingAddress;
  st: string;
}

const ShopPage = (props: ShopPageProps) => {
  return (
    <>
      <NextSeo
        noindex={process.env.NEXT_PUBLIC_STAGE !== 'production'}
        nofollow={process.env.NEXT_PUBLIC_STAGE !== 'production'}
        title={PAGE_SEO.SHOP_SEARCH.title}
        description={PAGE_SEO.SHOP_SEARCH.description}
      />
      <AppLayout
        isFooterExist={false}
        quickSize="full"
        layoutType="full"
        isGnbExist={false}
        content={<ShopSearch {...props} type="entire" />}
      />
    </>
  );
};

export default ShopPage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const { lat, lng, level } = context.query;

    const res = await shopSearchGateway(
      context.req,
      context.res,
      store.dispatch,
    ).getSidoData.exec({});

    let latitude = lat ? _.toNumber(lat) : SOUTH_KOREA_LAT;
    let longitude = lng ? _.toNumber(lng) : SOUTH_KOREA_LNG;
    let zoomLevel = level ? _.toNumber(level) : SOUTH_KOREA_LEVEL_MAX;

    if (res.data?.address) {
      latitude = lat ? latitude : res.data?.address.latitude;
      longitude = lng ? longitude : res.data?.address.longitude;
      zoomLevel = level ? zoomLevel : CURRENT_LEVEL;
    }

    if (!!latitude && !!longitude && !!zoomLevel) {
      store.dispatch(
        setShopSearchUrlParam({
          latitude,
          longitude,
          zoomLevel,
        }),
      );
    }

    return {
      props: {
        siDoList: res.data?.siDos,
        address: res.data?.address,
        st: context?.query?.st || '',
      },
    };
  },
);
